import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { Card, CardContent, Divider, Grid, List, ListItem, Stack, Typography } from '@mui/material'
import { reportError } from 'utils/errorReporter'
import _ from 'lodash'
import { AssignmentInd, ListAlt, Pageview, Settings } from '@mui/icons-material'
import { listScopes } from '../../../services/apiKYP'
import LoadingComponent, { horizontalLeftAlignedLoadingProps } from '../../LoadingComponent'

const ScopeManagement = (props) => {
  const { selectedUserRole } = props
  const [ scopesData, setScopesData ] = useState({})
  const token = useSelector((state) => state.auth.access_token)
  const [isLoading, setIsLoading] = useState(true)
  const loadingComponentProps = {
    ...horizontalLeftAlignedLoadingProps,
    loadingText: 'Carregando permissões...',
  }

  const fetchData = useCallback(() => {
    listScopes(token, selectedUserRole)
      .then((response) => {
        const scopesClassified = _.groupBy(response?.data?.items, (s) => s.classification)
        setScopesData(scopesClassified)
      })
      .catch((error) => {
        reportError(error)
        setScopesData({})
        if (error?.response?.data?.detail) {
          toast.error(error.response.data.detail)
        } else {
          toast.error('Erro ao obter os dados do servidor. Por favor, tente novamente mais tarde.')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [selectedUserRole])

  useEffect(() => {
    fetchData()
  }, [selectedUserRole])


  const groups = { 
    'manual_analysis': { 'name': 'Análises Manuais', 'icon': <Pageview fontSize='medium' /> },
    'due_diligence': { 'name': 'Due Diligence', 'icon': <ListAlt fontSize='medium' /> },
    'antifraude': { 'name': 'Jornada Antifraude', 'icon': <AssignmentInd fontSize='medium' /> },
    'administrative_config': { 'name': 'Configurações Administrativas', 'icon': <Settings fontSize='medium' /> },

  }

  return isLoading ? (
    <LoadingComponent {...loadingComponentProps} />
  ) : (
    <div>
      <h3>Permissões</h3>
      <div>
            <Grid container spacing={3} sx={{ p: 2, width: '100%' }}>
              {Object.entries(groups).map(([groupId, groupInfo]) => { 
                return scopesData[groupId] && (<Grid item xs={12} sm={6} md={3} key={groupId}>
                  <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent>

                      
                        <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                          {groupInfo.icon}
                          <Typography variant="subtitle1" component="div" gutterBottom>
                          {groupInfo.name}
                          </Typography>
                        </Stack>
                      
                      <List sx={{ listStyleType: 'disc', pl: 4, mt: 2 }}>
                        {_.sortBy(scopesData[groupId], i => i.description).map((item) => (
                          <ListItem 
                            key={item.description} 
                            sx={{ display: 'list-item', p: 0, mb: 0.5, fontSize: '1.5rem' }}
                          >
                            <Typography variant="body2">{item.description}</Typography>
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>)
              })}
            </Grid>
      </div>
    </div>
  )
}

export default ScopeManagement
